import { ValueOf } from '~/types/value-of'

export const searchFilterType = {
  ALL: 'ALL',
  BLOCK: 'BLOCK',
  TRANSACTION: 'TRANSACTION',
  ADDRESS: 'ADDRESS',
  MODULE: 'MODULE',
} as const

export type searchFilterType = ValueOf<typeof searchFilterType>